import { render, staticRenderFns } from "./travel-insurance-quote-details.vue?vue&type=template&id=6bbd3962&scoped=true"
import script from "./travel-insurance-quote-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-quote-details.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-quote-details.vue?vue&type=style&index=0&id=6bbd3962&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd3962",
  null
  
)

export default component.exports